export default "__VITE_ASSET__BgYcTrDU__"